/* tslint:disable */
/* eslint-disable */
/**
 * CMA API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompsPreferencesDto
 */
export interface CompsPreferencesDto {
    /**
     * 
     * @type {number}
     * @memberof CompsPreferencesDto
     */
    priceMin: number;
    /**
     * 
     * @type {number}
     * @memberof CompsPreferencesDto
     */
    priceMax: number;
    /**
     * 
     * @type {string}
     * @memberof CompsPreferencesDto
     */
    bedsMin: string;
    /**
     * 
     * @type {string}
     * @memberof CompsPreferencesDto
     */
    bedsMax: string;
    /**
     * 
     * @type {string}
     * @memberof CompsPreferencesDto
     */
    bathsMin: string;
    /**
     * 
     * @type {string}
     * @memberof CompsPreferencesDto
     */
    bathsMax: string;
    /**
     * 
     * @type {number}
     * @memberof CompsPreferencesDto
     */
    livingSpaceMin: number;
    /**
     * 
     * @type {number}
     * @memberof CompsPreferencesDto
     */
    livingSpaceMax: number;
    /**
     * 
     * @type {string}
     * @memberof CompsPreferencesDto
     */
    extraInformation?: string;
}

/**
 * Check if a given object implements the CompsPreferencesDto interface.
 */
export function instanceOfCompsPreferencesDto(value: object): value is CompsPreferencesDto {
    if (!('priceMin' in value) || value['priceMin'] === undefined) return false;
    if (!('priceMax' in value) || value['priceMax'] === undefined) return false;
    if (!('bedsMin' in value) || value['bedsMin'] === undefined) return false;
    if (!('bedsMax' in value) || value['bedsMax'] === undefined) return false;
    if (!('bathsMin' in value) || value['bathsMin'] === undefined) return false;
    if (!('bathsMax' in value) || value['bathsMax'] === undefined) return false;
    if (!('livingSpaceMin' in value) || value['livingSpaceMin'] === undefined) return false;
    if (!('livingSpaceMax' in value) || value['livingSpaceMax'] === undefined) return false;
    return true;
}

export function CompsPreferencesDtoFromJSON(json: any): CompsPreferencesDto {
    return CompsPreferencesDtoFromJSONTyped(json, false);
}

export function CompsPreferencesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompsPreferencesDto {
    if (json == null) {
        return json;
    }
    return {
        
        'priceMin': json['priceMin'],
        'priceMax': json['priceMax'],
        'bedsMin': json['bedsMin'],
        'bedsMax': json['bedsMax'],
        'bathsMin': json['bathsMin'],
        'bathsMax': json['bathsMax'],
        'livingSpaceMin': json['livingSpaceMin'],
        'livingSpaceMax': json['livingSpaceMax'],
        'extraInformation': json['extraInformation'] == null ? undefined : json['extraInformation'],
    };
}

export function CompsPreferencesDtoToJSON(json: any): CompsPreferencesDto {
    return CompsPreferencesDtoToJSONTyped(json, false);
}

export function CompsPreferencesDtoToJSONTyped(value?: CompsPreferencesDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'priceMin': value['priceMin'],
        'priceMax': value['priceMax'],
        'bedsMin': value['bedsMin'],
        'bedsMax': value['bedsMax'],
        'bathsMin': value['bathsMin'],
        'bathsMax': value['bathsMax'],
        'livingSpaceMin': value['livingSpaceMin'],
        'livingSpaceMax': value['livingSpaceMax'],
        'extraInformation': value['extraInformation'],
    };
}

